module.exports = __webpack_public_path__ + "static/media/reward.a821a43c.svg";